<template>
    <div>
        <template v-if="loading">
            <i class="fas fa-cog fa-spin"></i> Loading...
        </template>
        <template v-else>
            <vue-headful :title="client.first_name + ' '+client.last_name+' [Client] - AMOS365'" />

            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/clients">Clients</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">{{ client.first_name }} {{ client.last_name }}</li>
                </ol>
            </nav>

            <h4 class="page-header mb-4">
                {{ client.first_name }} {{ client.last_name }}
            </h4>

            <div class="mb-3" v-if="canEdit">
                <router-link :to="`/clients/edit/${client.id}`" class="btn btn-sm btn-default"><i class="fas fa-edit"></i> Edit</router-link>
            </div>

            <div class="row mt-2 mb-4">
                <div class="col-md-8 col-12">

                    <div class="card mb-4">
                        <div class="card-header"><strong>Details</strong></div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-8 mb-md-0">
                                    <div class="row mb-3">
                                        <div class="col-md-4 text-md-right text-muted">First Name:</div>
                                        <div class="col-md-7">{{ client.first_name }}</div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-md-4 text-md-right text-muted">Last Name:</div>
                                        <div class="col-md-7">{{ client.last_name }}</div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-md-4 text-md-right text-muted">Middle Name:</div>
                                        <div class="col-md-7">{{ client.middle_name }}</div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-md-4 text-md-right text-muted">Spouse Name:</div>
                                        <div class="col-md-7">{{ client.spouse_name }}</div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-md-4 text-md-right text-muted">Number of Children:</div>
                                        <div class="col-md-7">{{ client.number_of_children }}</div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-md-4 text-md-right text-muted">Last Updated At:</div>
                                        <div class="col-md-7">{{ client.updated_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}</div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-md-4 text-md-right text-muted">Last Updated By:</div>
                                        <div class="col-md-7">{{ client.last_updated_by }}</div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-md-4 text-md-right text-muted">Active:</div>
                                        <div class="col-md-7">
                                            <label class="badge badge-success" v-if="client.is_active == 1">Active</label>
                                            <label class="badge badge-warning" v-else-if="client.is_active == 0">Inactive</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header"><strong>Identification</strong></div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-8 mb-md-0">
                                    <div class="row mb-3">
                                        <div class="col-md-4 text-md-right text-muted">Medicare:</div>
                                        <div class="col-md-7">
                                            {{ client.medicare }}
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-md-4 text-md-right text-muted">SSN:</div>
                                        <div class="col-md-7">
                                            <span v-if="$root.hasPermission('clients.view.sensitive')">{{ client.ssn | ssn }}</span>
                                            <span v-else>-- Hidden --</span>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-md-4 text-md-right text-muted">Date of Birth:</div>
                                        <div class="col-md-7">
                                            <span v-if="$root.hasPermission('clients.view.sensitive')">
                                                <span v-if="client.date_of_birth">{{ client.date_of_birth | moment("MM/DD/YYYY") }}</span>
                                            </span>
                                            <span v-else>-- Hidden --</span>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-md-4 text-md-right text-muted">Spouse SSN:</div>
                                        <div class="col-md-7">
                                            <span v-if="$root.hasPermission('clients.view.sensitive')">{{ client.spouse_ssn | ssn }}</span>
                                            <span v-else>-- Hidden --</span>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-md-4 text-md-right text-muted">Spouse Date of Birth:</div>
                                        <div class="col-md-7">
                                            <span v-if="$root.hasPermission('clients.view.sensitive')">
                                                <span v-if="client.date_of_birth">{{ client.spouse_date_of_birth | moment("MM/DD/YYYY") }}</span>
                                            </span>
                                            <span v-else>-- Hidden --</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header"><strong>Notes</strong></div>
                        <div class="card-body">
                            <div v-if="client.notes">{{ client.notes }}</div>
                            <div v-else>--</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-12">
                    <div class="card mb-4">
                        <div class="card-header"><strong>Emails ({{ client.emails.length }})</strong></div>
                        <div class="card-body">
                            <email-list :emails="client.emails" />
                        </div>
                    </div>
                    <div class="card mb-4">
                        <div class="card-header"><strong>Phones ({{ client.phones.length }})</strong></div>
                        <div class="card-body">
                            <phone-list :phones="client.phones" />
                        </div>
                    </div>
                    <div class="card mb-4">
                        <div class="card-header"><strong>Addresses ({{ client.addresses.length }})</strong></div>
                        <div class="card-body">
                            <address-list :addresses="client.addresses" />
                        </div>
                    </div>
                </div>
            </div>

            <ul class="search-nav nav nav-tabs tabs-alt container-m--x mt-4 d-lg-flex d-none">
                <b-nav-item :active="curTab === item.key" @click="curTab = item.key" v-for="item in tabs" :key="item.key">
                    <i :class="`fa fa-${item.icon}`"></i> {{ item.title }}
                </b-nav-item>
            </ul>

            <div class="mb-2 mb-lg-0 d-lg-none d-block">
                <b-dropdown :html="tabTitle" variant="default" class="bg-white">
                    <b-dropdown-item :active="curTab === item.key" @click="curTab = item.key" v-for="item in tabs" :key="item.key">
                        <i :class="`fa fa-${item.icon}`"></i> {{ item.title }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>

            <div class="pt-2">
                <div v-show="curTab === 'comments'">
                    <template v-if="$root.hasPermission('comments.create')">
                        <comments-form ref="clientCommentForm" assetType="Client" :assetId="client.id" @commentCreated="newComment" @commentUpdated="updateComment"></comments-form>
                        <hr/>
                    </template>

                    <comments-list ref="clientComments" assetType="Client" :assetId="client.id" :ajaxLoad="true" @editComment="editComment" @commentCount="setCommentCount"></comments-list>
                </div>
                <div class="card" v-show="curTab === 'files'">
                    <div class="card-body">
                        <files-list :files="files" />
                    </div>
                </div>
                <div v-show="curTab === 'history'">
                    <div class="card">
                        <div class="card-body">
                            <history-list :record_id="client.id" record_type="Client" @historyCount="(count) => { this.historyCount = count; }" />
                        </div>
                    </div>
                </div>
            </div>
        </template>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                curTab: 'comments',
                id: this.$route.params.id,
                userTimezone: this.$root.timezone,
                client: {},
                parts: [],
                comments: [],
                all_comments: [],
                files: [],
                totalComments: 0,
                historyCount: 0,
            }
        },

        computed: {
            canEdit(){
                //Check Permissions
                return this.$root.hasPermission('clients.manage');
            },

            tabs(){
                return [
                    {key: 'comments', title: 'Comments ('+this.totalComments+')', icon: 'comments'},
                    {key: 'files', title: 'Files ('+this.files.length+')', icon: 'clone'},
                    {key: 'history', title: 'History ('+this.historyCount+')', icon: 'clock'},
                ];
            },

            tabTitle(){
                //Loop
                for (var i = this.tabs.length - 1; i >= 0; i--)
                {
                    //Check tabl
                    if(this.tabs[i].key === this.curTab)
                    {
                        return '<i class="fa fa-'+this.tabs[i].icon+'"></i> ' + this.tabs[i].title;
                    }
                }

                //Send it
                return '';
            },
        },

        methods: {
            //Get the Client
            getClient(){
                //Send it
                this.$http.get('/clients/view/'+this.id)
                    .then(response => {
                        //Set the client
                        this.client = response.data.client;
                        this.files = response.data.files;
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            setCount(data){
                //Setter
                this.assignedCount = data;
            },

            editComment(comment){
                //Push into the component
                this.$refs.clientCommentForm.editComment(comment);
            },

            newComment(comment){
                //Push it
                this.$refs.clientComments.addComment(comment);
            },

            updateComment(comment){
                //Update it
                this.$refs.clientComments.updateComment(comment);
            },

            setCommentCount(count){
                //SEt it
                this.totalComments = count;
            },
        },

        mounted() {
            //Get the client
            this.getClient();
        }
    }
</script>
